export const titleCase = (str: string) => {
  return str
    ?.toLowerCase()
    ?.split(' ')
    ?.map((word = '') => word.replace(word[0], word[0]?.toUpperCase()))
    ?.join(' ')
    ?.replace(/ And /g, ' and ');
};

export const camelCaseToTitleCase = (str: string) => {
  if (!str) return '';

  return (
    str[0].toUpperCase() +
    str
      .slice(1)
      .replace(/([A-Z])/g, ' $1')
      .trim()
  );
};

/**
 * Memo label formatting: 'phoneCall' → 'Phone Call'. Splits at the FIRST
 * capital only, then title-cases — distinct from camelCaseToTitleCase, which
 * splits at every capital. Shared by the Memos tab, the memo modal, and the
 * printout so their labels cannot drift.
 */
export const addSpaceBeforeFirstCapital = (str: string) => {
  const firstCapitalIndex = str.search(/[A-Z]/);

  if (firstCapitalIndex === -1) {
    return titleCase(str);
  }

  return titleCase(`${str.slice(0, firstCapitalIndex)} ${str.slice(firstCapitalIndex)}`);
};
